import Tour from '@core/components/Tour';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { permissaoUtils } from '@core/util/permissaoUtil';
import FusePageSimple from '@fuse/core/FusePageSimple';
import { Grid, TablePagination, Tooltip, Typography } from '@material-ui/core';
import { confirmarAlert } from 'app/services/alerts';
import conciliacaoApi from 'app/services/api/conciliacaoApi';
import { usuarioApi } from 'app/services/api/usuarioApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA, initializeReactGA } from 'app/utils/analyticsUtil';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ContaReceberVisualizacaoModal } from '../contareceber/components/modal';
import { ContaReceberProvider } from '../contareceber/contaReceberContext';
import { ContasPagarVisualizar } from '../contaspagar/container';
import { ContasPagarProvider } from '../contaspagar/store';
import makeConciliacao from './MakeConciliacao';
import { ConciliacaoContext, ConciliacaoProvider } from './components/ConciliacaoContext';
import ConciliacaoMenuAcoes from './components/ConciliacaoMenuAcoes';
import { Header } from './components/Header';
import ContainerInformacaoExtrato from './components/containers/ContainerExtratoInfo';
import {
  ContainerLancamentoExtratoBancario,
  ExtratoItem,
} from './components/containers/ContainerLancamentoExtratoBancario';
import ContainerLancamentos from './components/containers/ContainerLancamentos';
import ContentInformacaoExtrato from './components/contents/ContentInformacaoExtrato';
import ContentLancamento from './components/contents/ContentLancamento';
import Dashboard from './components/dashboard/Dashboard';
import AcrescimoDescontoModal from './components/modal/AcrescimoDescontoModal';
import CadastrarTransferencia from './components/modal/CadastrarTransferencia';
import { ConciliacaoModal } from './components/modal/ConciliacaoModal';
import ImportarArquivoModal from './components/modal/ImportarArquivoModal';
import RegraAutomaticaCadastro from './components/regrasautomaticas/RegraAutomaticaCadastro';
import RegraAutomaticaModal from './components/regrasautomaticas/RegraAutomaticaModal';
import { conciliacaoSteps } from './components/steps/ConciliacaoSteps';

const Conciliacao = () => {
  const [conciliacoes, setConciliacoes] = useContext(ConciliacaoContext).conciliacoes;
  const [searchConciliacoes, setSearchConciliacoes] = useContext(ConciliacaoContext).searchConciliacoes;
  const [credito, setCredito] = useContext(ConciliacaoContext).credito;
  const [filtro] = useContext(ConciliacaoContext).filtro;
  const [contaBancaria] = useContext(ConciliacaoContext).contaBancaria;
  const [debito, setDebito] = useContext(ConciliacaoContext).debito;
  const [, setSelecao] = useContext(ConciliacaoContext).selecao;
  const [saldoFinal, setSaldoFinal] = useContext(ConciliacaoContext).saldoFinal;
  const [conciliacoesPendentes, setConciliacoesPendentes] = useContext(ConciliacaoContext).conciliacoesPendentes;
  const [, setExtratoSelecionado] = useContext(ConciliacaoContext).extratoSelecionado;
  const [, setModal] = useContext(ConciliacaoContext).modal;
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;
  const [loading, setLoading] = useState(false);
  const [run, setRun] = useState(false);
  const [, setOnTour] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const leituraArquivo = useRef(false);

  const CONCILIACAO = 'Conciliação';

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    buscarTour();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitialValues = (registro) => ({
    ...registro,
    conta: registro?.conta,
    dataInicio: registro?.dataInicio,
    dataFim: registro?.dataFim,
    tipo: registro?.tipo || 'TODOS',
    situacao: registro?.situacao || 'NAO_CONCILIADO',
  });

  const formikFiltro = useFormik({
    initialValues: getInitialValues(filtro),
    validateOnChange: true,
    validateOnBlur: true,
  });

  const handleChangePage = (event, page) => {
    buscarLancamentos(filtro, {
      ...searchConciliacoes,
      page,
    });
  };

  const buscarLancamentos = async (filtros, search = searchConciliacoes) => {
    setLoading(true);

    try {
      setSelecao([]);
      setConciliacoes([]);
      setCredito(0);
      setDebito(0);
      setSaldoFinal(0);
      setConciliacoesPendentes(0);

      const resp = await conciliacaoApi.buscarLancamentos(filtros, search);

      setSearchConciliacoes({
        size: resp.data.lancamentoExtratoBancarioResponse.size,
        page: resp.data.lancamentoExtratoBancarioResponse.number,
        totalElements: resp.data.lancamentoExtratoBancarioResponse.totalElements,
        sort: searchConciliacoes?.sort,
      });

      if (resp.data.lancamentoExtratoBancarioResponse.content.length !== 0) {
        setConciliacoes(resp.data.lancamentoExtratoBancarioResponse.content);
        setCredito(filtros?.situacao === 'CONCILIADO' ? 0 : Math.abs(resp.data.creditoDiferenca));
        setDebito(filtros?.situacao === 'CONCILIADO' ? 0 : Math.abs(resp.data.debitoDiferenca));
        setSaldoFinal(filtros?.situacao === 'CONCILIADO' ? 0 : resp.data.saldoFinal);
        setConciliacoesPendentes(filtros?.situacao === 'CONCILIADO' ? 0 : resp.data.conciliacoesPendentes);
      } else {
        setConciliacoes([]);
        showError('Nenhum registro foi encontrado.');
      }
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const ORIGEM = {
    DIFERENTE_CONCILIACAO: 'DIF_CONNCILIACAO',
    CONCILIACAO: 'CONCILIACAO',
    DISTINTAS: 'DISTINTAS',
  };

  useReduxLoading(loading);

  const total = (contaPagarList, contaReceberList, transferenciaBancaria, receitasDespesas) => {
    let total = 0;
    if (transferenciaBancaria) {
      total = transferenciaBancaria?.valor;
    } else if (receitasDespesas) {
      let totalDespesa = 0;
      let totalReceita = 0;
      if (contaPagarList && contaPagarList.length > 0) {
        contaPagarList.forEach((contaPagar) => {
          totalDespesa += contaPagar?.baixa ? contaPagar?.baixa?.valorPago : contaPagar.valor ? contaPagar.valor : 0;
        });
      }

      if (contaReceberList && contaReceberList.length > 0) {
        contaReceberList.forEach((contaReceber) => {
          totalReceita += contaReceber?.baixa
            ? contaReceber?.baixa?.valorPago
            : contaReceber.valor
            ? contaReceber.valor
            : 0;
        });
      }
      total = totalReceita - totalDespesa;
    } else if (contaPagarList) {
      contaPagarList.forEach((contaPagar) => {
        total += contaPagar?.baixa ? contaPagar?.baixa?.valorPago : contaPagar.valor ? contaPagar.valor : 0;
      });
    } else if (contaReceberList) {
      contaReceberList.forEach((contaReceber) => {
        total += contaReceber?.baixa ? contaReceber?.baixa?.valorPago : contaReceber.valor ? contaReceber.valor : 0;
      });
    }
    return total;
  };

  const makeDesconciliacoes = (extratos) => {
    let listIdDesconciliacao = [];
    extratos.forEach((extrato) => {
      listIdDesconciliacao.push(extrato.id);
    });
    return listIdDesconciliacao;
  };

  const validarPermissaoContaPagar = (contaPagarList) => {
    if (contaPagarList) {
      if (contaPagarList.length === 1) {
        if (contaPagarList[0].id) {
          if (!permissaoUtils.contaPagar().editar) {
            showError('Você não tem permissão para editar uma conta a pagar. Peça autorização para o administrador.');
            return false;
          }
        } else {
          if (!permissaoUtils.contaPagar().cadastrar) {
            showError('Você não tem permissão para criar uma conta a pagar. Peça autorização para o administrador.');
            return false;
          }
        }
      } else {
        if (permissaoUtils.contaPagar().editar && permissaoUtils.contaPagar().cadastrar) {
          return true;
        } else if (permissaoUtils.contaPagar().cadastrar) {
          if (contaPagarList.filter((despesa) => despesa.id).length > 1) {
            showError('Você não tem permissão para editar uma conta a pagar. Peça autorização para o administrador.');
            return false;
          }
        } else {
          if (contaPagarList.filter((despesa) => !!despesa.id).length > 1) {
            showError(
              'Você não tem permissão para cadastrar uma conta a pagar. Peça autorização para o administrador.'
            );
            return false;
          }
        }
      }
    }
    return true;
  };

  const validarPermissaoContaReceber = (contaReceberList) => {
    if (contaReceberList) {
      if (contaReceberList.length === 1) {
        if (contaReceberList[0].id) {
          if (!permissaoUtils.contaReceber().editar) {
            showError('Você não tem permissão para editar uma conta a receber. Peça autorização para o administrador.');
            return false;
          }
        } else {
          if (!permissaoUtils.contaReceber().cadastrar) {
            showError('Você não tem permissão para criar uma conta a receber. Peça autorização para o administrador.');
            return false;
          }
        }
      } else {
        if (permissaoUtils.contaReceber().editar && permissaoUtils.contaReceber().cadastrar) {
          return true;
        } else if (permissaoUtils.contaReceber().cadastrar) {
          if (contaReceberList.filter((receita) => receita.id).length > 1) {
            showError('Você não tem permissão para editar uma conta a receber. Peça autorização para o administrador.');
            return false;
          }
        } else {
          if (contaReceberList.filter((receita) => !!receita.id).length > 1) {
            showError(
              'Você não tem permissão para cadastrar uma conta a receber. Peça autorização para o administrador.'
            );
            return false;
          }
        }
      }
    }
    return true;
  };

  const validarPermissoes = (extrato) => {
    return validarPermissaoContaPagar(extrato.contaPagarList) && validarPermissaoContaReceber(extrato.contaReceberList);
  };

  const handlerConciliar = async (extrato) => {
    setLoading(true);

    let tipo;
    if (Math.sign(extrato?.valor) === -1) {
      tipo = 'DESPESA';
    } else {
      tipo = 'RECEITA';
    }

    if (!validarPermissoes(extrato)) {
      setLoading(false);
      return;
    }

    const totalLancamentos = total(
      extrato?.contaPagarList,
      extrato?.contaReceberList,
      extrato?.transferenciaBancariaForm,
      extrato?.receitasDespesas
    );

    if (Math.abs(totalLancamentos.toFixed(2)) !== Math.abs(extrato?.valor.toFixed(2))) {
      if (extrato.contaReceberList) {
        handleContaReceber(extrato, tipo, totalLancamentos);
        setLoading(false);
      } else {
        handleContaPagar(extrato, tipo, totalLancamentos);
        setLoading(false);
      }
    } else {
      try {
        const aux = makeConciliacao.makeConciliacoes([extrato]);

        let conciliacaoFilter = conciliacoes;
        for (let i = 0; i < aux.length; i++) {
          conciliacaoFilter = conciliacaoFilter.filter((conciliacao) => conciliacao.id !== aux[i].id);
        }
        setConciliacoes([]);

        eventReactGA(CONCILIACAO, 'Conciliar');
        const resp = await conciliacaoApi.conciliar(aux);

        if (resp.status === 200) {
          setConciliacoes(conciliacaoFilter);
          atualizarDashboard(resp);
          setLoading(false);
          showSuccess('Conciliação realizada com sucesso.');
        } else {
          setConciliacoes(conciliacoes);
        }
        setLoading(false);
      } catch (err) {
        setConciliacoes(conciliacoes);
        setLoading(false);
        apiUtils.handleApiError(err);
      }
    }
  };

  const desconciliar = async (listId, isSelecionados) => {
    setLoading(true);

    try {
      eventReactGA(CONCILIACAO, isSelecionados ? 'Desconciliar selecionados' : 'Desconciliar');
      const resp = await conciliacaoApi.desconciliar(listId);

      const idsDesconciliados = [];

      for (let i = 0; i < resp.data.length; i++) {
        idsDesconciliados.push(resp.data[i].id);
      }

      if (resp.status === 200) {
        const conciliacaoFilter = conciliacoes.filter((conciliacao) => !idsDesconciliados.includes(conciliacao.id));

        setConciliacoes(conciliacaoFilter);
        atualizarDashboard(resp);
        setLoading(false);
        showSuccess('Desconciliação realizada com sucesso.');
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      apiUtils.handleApiError(err);
    }
  };

  const atualizarDashboard = (conciliacoes) => {
    let creditoAtualizado = credito;
    let debitoAtualizado = debito;

    for (let i = 0; i < conciliacoes.data.length; i++) {
      if (conciliacoes.data[i].valor > 0) {
        creditoAtualizado = creditoAtualizado - Math.abs(conciliacoes.data[i].valor);
      } else {
        debitoAtualizado = debitoAtualizado - Math.abs(conciliacoes.data[i].valor);
      }
    }

    setCredito(formikFiltro?.values?.situacao === 'CONCILIADO' ? 0 : creditoAtualizado);
    setDebito(formikFiltro?.values?.situacao === 'CONCILIADO' ? 0 : debitoAtualizado);
    setSaldoFinal(formikFiltro?.values?.situacao === 'CONCILIADO' ? 0 : Math.abs(creditoAtualizado - debitoAtualizado));
    setConciliacoesPendentes(
      formikFiltro?.values?.situacao === 'CONCILIADO' ? 0 : conciliacoesPendentes - conciliacoes.data.length
    );
  };

  const getAlertDesconciliar = (origem, listId) => {
    if (origem === ORIGEM.DIFERENTE_CONCILIACAO) {
      return {
        confirmar: () => desconciliar(listId, false),
        titulo: 'Tem certeza que deseja desconciliar?',
        mensagem: '',
      };
    }

    if (origem === ORIGEM.CONCILIACAO) {
      return {
        confirmar: () => desconciliar(listId, false),
        titulo: 'As contas originadas na conciliação bancária serão excluídas após desconciliação.',
        mensagem: 'Deseja continuar?',
      };
    }

    if (origem === ORIGEM.DISTINTAS) {
      return {
        confirmar: () => desconciliar(listId, false),
        titulo:
          'Há contas selecionadas de origens distintas. As contas originadas pela conciliação bancária serão excluídas.',
        mensagem: 'Deseja continuar?',
      };
    }
  };

  const getOrigemLancamentos = (extrato) => {
    if (extrato?.contaPagarList) {
      const tamanho = extrato?.contaPagarList.length;
      const tamanhoFilter = extrato?.contaPagarList.filter((despesa) => despesa.origemLancamento === 'CONCILIACAO')
        .length;
      return tamanhoFilter === 0
        ? ORIGEM.DIFERENTE_CONCILIACAO
        : tamanho === tamanhoFilter
        ? ORIGEM.CONCILIACAO
        : ORIGEM.DISTINTAS;
    } else if (extrato?.contaReceberList) {
      const tamanho = extrato?.contaReceberList.length;
      const tamanhoFilter = extrato?.contaReceberList.filter((receita) => receita.origemLancamento === 'CONCILIACAO')
        .length;
      return tamanhoFilter === 0
        ? ORIGEM.DIFERENTE_CONCILIACAO
        : tamanho === tamanhoFilter
        ? ORIGEM.CONCILIACAO
        : ORIGEM.DISTINTAS;
    }
  };

  const handlerDesconciliar = async (extrato) => {
    setLoading(true);
    const aux = makeDesconciliacoes([extrato]);
    const origem = getOrigemLancamentos(extrato);
    if (origem) {
      confirmarAlert(getAlertDesconciliar(origem, aux));
    } else {
      desconciliar(aux, false);
    }
    setLoading(false);
  };

  const handleContaPagar = (extrato, tipo, totalLancamentos) => {
    if (extrato.contaPagarList && extrato.contaPagarList.length === 1) {
      if (extrato.contaPagarList[0].situacao !== 'BAIXADA') {
        confirmarAlert({
          confirmar: () => {
            setExtratoSelecionado({
              valorExtrato: Math.abs(extrato?.valor),
              valorReceitaDespesa: Math.abs(totalLancamentos),
              valorDiferenca: Math.abs(totalLancamentos - Math.abs(extrato?.valor)),
              extratoId: extrato.id,
              lancamentoExtrato: extrato,
              contaPagarList: [extrato.contaPagarList[0]],
              tipo: tipo,
            });

            setModal(ConciliacaoModal.acrecimoDesconto);
          },
          titulo: 'O valor informado está diferente do extrato.',
          mensagem: 'Deseja lançar a diferença como juros, multa e/ou desconto?',
        });
      } else {
        showError(
          'Não é possível conciliar pois a conta selecionada está baixada e o valor está divergente do valor total do extrato.'
        );
      }
    } else {
      showError('O valor total dos registros selecionados está divergente do valor total do extrato.');
    }
  };

  const handleContaReceber = (extrato, tipo, totalLancamentos) => {
    if (extrato.contaReceberList && extrato.contaReceberList.length === 1) {
      if (extrato.contaReceberList[0].situacao !== 'BAIXADA') {
        confirmarAlert({
          confirmar: () => {
            setExtratoSelecionado({
              valorExtrato: Math.abs(extrato?.valor),
              valorReceitaDespesa: Math.abs(totalLancamentos),
              valorDiferenca: Math.abs(totalLancamentos - Math.abs(extrato?.valor)),
              extratoId: extrato.id,
              lancamentoExtrato: extrato,
              contaReceberList: [extrato.contaReceberList[0]],
              contaPagarList: extrato.contaPagarList ? [extrato.contaPagarList[0]] : [],
              tipo: tipo,
              receitasDespesas: extrato.receitasDespesas,
            });

            setModal(ConciliacaoModal.acrecimoDesconto);
          },
          titulo: 'O valor informado está diferente do extrato.',
          mensagem: 'Deseja lançar a diferença como juros, multa e/ou desconto?',
        });
      } else {
        showError(
          'Não é possível conciliar pois a conta selecionada está baixada e o valor está divergente do valor total do extrato.'
        );
      }
    } else {
      showError('O valor total dos registros selecionados está divergente do valor total do extrato.');
    }
  };

  const validarPermissoesSelecionados = (selecionados) => {
    let ok = true;
    selecionados.forEach((extrato) => {
      if (ok && !validarPermissoes(extrato)) {
        ok = false;
      }
    });
    return ok;
  };

  const conciliarSelecionados = async (selecionados) => {
    setLoading(true);
    if (validarPermissoesSelecionados(selecionados)) {
      if (existeLancamento(selecionados)) {
        if (valoresValido(selecionados)) {
          try {
            const aux = makeConciliacao.makeConciliacoes(selecionados);

            let conciliacaoFilter = conciliacoes;
            for (let i = 0; i < aux.length; i++) {
              conciliacaoFilter = conciliacaoFilter.filter((conciliacao) => conciliacao.id !== aux[i].id);
            }
            setConciliacoes([]);

            eventReactGA(CONCILIACAO, 'Conciliar selecionados');
            const resp = await conciliacaoApi.conciliar(aux);

            if (resp.status === 200) {
              setConciliacoes(conciliacaoFilter);
              atualizarDashboard(resp);
              setLoading(false);
              showSuccess('Conciliação realizada com sucesso.');
            }
          } catch (err) {
            setLoading(false);
            apiUtils.handleApiError(err);
          }
        } else {
          showError('Não foi possível conciliar pois os valores estão divergentes.');
        }
      } else {
        showError('Não existem contas relacionadas para serem conciliadas.');
      }
    }

    setLoading(false);
  };

  const desconciliarSelecionados = async (selecionados) => {
    const origens = [];
    selecionados.forEach((extrato) => {
      const origemAux = getOrigemLancamentos(extrato);
      if (origemAux) {
        origens.push(origemAux);
      }
    });

    const tamanho = origens.length;
    const tamanhoFilter = origens.filter((origem) => origem === 'CONCILIACAO').length;

    const origem =
      tamanho === 0
        ? undefined
        : tamanhoFilter === 0
        ? ORIGEM.DIFERENTE_CONCILIACAO
        : tamanho === tamanhoFilter
        ? ORIGEM.CONCILIACAO
        : ORIGEM.DISTINTAS;

    const aux = makeDesconciliacoes(selecionados);
    if (origem) {
      confirmarAlert(getAlertDesconciliar(origem, aux));
    } else {
      desconciliar(aux, true);
    }
  };

  const existeLancamento = (selecionados) => {
    let ok = true;
    selecionados.forEach((extrato) => {
      if (ok && !extrato.contaPagarList && !extrato.contaReceberList && !extrato.transferenciaBancariaForm) {
        ok = false;
      }
    });
    return ok;
  };

  const valoresValido = (selecionados) => {
    let ok = true;
    selecionados.forEach((extrato) => {
      const totalLancamentos = total(
        extrato?.contaPagarList,
        extrato?.contaReceberList,
        extrato?.transferenciaBancariaForm,
        extrato?.receitasDespesas
      );
      if (ok && Math.abs(totalLancamentos) !== Math.abs(extrato?.valor)) {
        ok = false;
      }
    });
    return ok;
  };

  const buscarTour = () => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((f) => f === 'CONCILIACAO_BANCARIA');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setOnTour(true);
    }
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('CONCILIACAO_BANCARIA');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setOnTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContasPagarProvider>
      <ContaReceberProvider>
        <FusePageSimple
          innerScroll
          content={
            <>
              <Tour steps={conciliacaoSteps} run={run} setRun={setRun} onFinish={() => atualizarTour()} />

              <ContasPagarVisualizar semAcoes origemConciliacao />
              <ContaReceberVisualizacaoModal semAcoes origemConciliacao />
              <Grid container>
                <Grid container>
                  <Header />
                </Grid>
                {contaBancaria !== undefined && (
                  <Grid container spacing={2} style={{ margin: '25px 40px 0px' }}>
                    <Grid container style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                      <Typography style={{ fontSize: 19, fontWeight: 'bold', marginRight: 10 }}>
                        {`${contaBancaria?.contaBancariaNomeReferencia} - ${contaBancaria?.contaDescricao} - ${contaBancaria?.contaTipo}`}
                      </Typography>
                      <Tooltip
                        title={`Agência: ${contaBancaria?.contaBancariaAgencia} / Conta: ${contaBancaria?.contaBancariaConta}`}
                        placement="right-end"
                      >
                        <button type="button" onClick={() => {}}>
                          <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
                        </button>
                      </Tooltip>
                    </Grid>
                  </Grid>
                )}
                <Grid container spacing={2} style={{ margin: '15px 32px 22px' }}>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Dashboard
                      titulo="Crédito"
                      valor={credito}
                      descricao="de diferença"
                      cor="#3286a8"
                      className={'stepCredito'}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Dashboard
                      titulo="Débito"
                      valor={debito}
                      descricao="de diferença"
                      cor="#b53838"
                      className={'stepDebito'}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Dashboard
                      titulo="Saldo final"
                      valor={saldoFinal}
                      descricao="de diferença"
                      cor="#000"
                      className={'stepSaldoFinal'}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <Dashboard
                      titulo="Conciliações pendentes no extrato"
                      valor={conciliacoesPendentes}
                      cor="#e88e18"
                      noCurrency
                      className={'stepConciliacoesPendentes'}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <ContainerLancamentos
                      formikFiltro={formikFiltro}
                      leituraArquivo={leituraArquivo}
                      buscarLancamentos={buscarLancamentos}
                    >
                      <ConciliacaoMenuAcoes
                        conciliarSelecionados={conciliarSelecionados}
                        desconciliarSelecionados={desconciliarSelecionados}
                      />
                      <ContainerLancamentoExtratoBancario>
                        {conciliacoes &&
                          conciliacoes.map((extrato, index) => (
                            <ExtratoItem
                              key={index}
                              info={
                                extrato.valor !== 0 && (
                                  <ContainerInformacaoExtrato extrato={extrato}>
                                    <ContentInformacaoExtrato
                                      data={
                                        extrato.data
                                          ? moment(extrato.data, 'DD/MM/YYYY')
                                          : moment(extrato.dataHoraLancamento)
                                      }
                                      descricao={extrato.descricao}
                                      valor={extrato.valor}
                                    />
                                  </ContainerInformacaoExtrato>
                                )
                              }
                              form={
                                <ContentLancamento
                                  index={index}
                                  extrato={extrato}
                                  handlerConciliar={handlerConciliar}
                                  handlerDesconciliar={handlerDesconciliar}
                                />
                              }
                            />
                          ))}
                      </ContainerLancamentoExtratoBancario>
                      <TablePagination
                        component="div"
                        className="pb-0"
                        style={{ display: 'flex', justifyContent: 'center' }}
                        count={searchConciliacoes.totalElements}
                        rowsPerPage={searchConciliacoes.size}
                        labelRowsPerPage={false}
                        page={searchConciliacoes.page}
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                        onChangePage={handleChangePage}
                        rowsPerPageOptions={[]}
                      />
                    </ContainerLancamentos>
                    <ImportarArquivoModal formikFiltro={formikFiltro} leituraArquivo={leituraArquivo} />
                    <AcrescimoDescontoModal filtros={filtro} />

                    <CadastrarTransferencia origemConciliacao />
                    <RegraAutomaticaModal />

                    <RegraAutomaticaCadastro />
                  </Grid>
                </Grid>
              </Grid>
            </>
          }
        />
      </ContaReceberProvider>
    </ContasPagarProvider>
  );
};

const ConciliacaoContainer = () => (
  <ConciliacaoProvider>
    <Conciliacao />
  </ConciliacaoProvider>
);
export default ConciliacaoContainer;
